/* 文言は snippets/upsell-offer.liquid が #dcw-i18n-upsell に出す（言語ごと）。無ければ日本語（2026-10-06） */
function T(k, fb) {
  try { var j = JSON.parse((document.getElementById('dcw-i18n-upsell') || {}).textContent || '{}'); return j[k] || fb; }
  catch (e) { return fb; }
}
/*
  「こちらもいかがですか」（snippets/upsell-offer.liquid）の操作（2026-10-05）
  - 商品ページの欄は 2026-10-23 に廃止（同時追加の処理も削除）。いまはカート画面だけ
  - カート画面: 「カートに追加」で追加し、明細・小計・バッジを描き直す
  - GA4: upsell_open（開いた）/ upsell_add（追加した）。placement = cart
*/
(function () {
  if (window.dcwUpsell) return;
  window.dcwUpsell = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function track(name, params) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, Object.assign({ send_to: 'G-YJ53NB0E09' }, params));
      }
    } catch (e) {}
  }

  function inner(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        return data;
      });
  }

  function placement(el) {
    var box = el.closest('[data-upsell-offer]');
    return box ? box.dataset.context : '';
  }

  // 開いた回数（中身まで見てもらえたか）。toggle は泡立たないので capture で拾う
  document.addEventListener(
    'toggle',
    function (e) {
      var d = e.target;
      if (!d.matches || !d.matches('[data-upsell-item]') || !d.open) return;
      track('upsell_open', { item_name: d.dataset.title, placement: placement(d) });
    },
    true
  );

  // 色・サイズを選んだら、追加する variant と小写真を差し替える（10/6）
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-upsell-variant]');
    if (!sel) return;
    var item = sel.closest('[data-upsell-item]');
    item.dataset.variantId = sel.value;
    var opt = sel.options[sel.selectedIndex];
    var img = item.querySelector('.upsell-offer__thumb img');
    if (img && opt && opt.dataset.thumb) {
      img.removeAttribute('srcset');
      img.src = opt.dataset.thumb;
    }
    var sw = item.querySelector('[data-upsell-swatch] img');
    if (sw && opt && opt.dataset.swatch) {
      sw.src = opt.dataset.swatch;
      sw.alt = opt.textContent.trim();
    }
  });

  // カート画面
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    var item = btn.closest('[data-upsell-item]');
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    var sections = ['cart-icon-bubble'];
    if (items && items.dataset.id) sections.push(items.dataset.id);
    if (footer && footer.dataset.id) sections.push(footer.dataset.id);

    btn.disabled = true;
    btn.textContent = T('adding', '追加中…');  // dcw-i18n-ignore JSON が無いときの予備（日本語ページと同じ文言）
    post('cart/add.js', {
      id: Number(item.dataset.variantId),
      quantity: 1,
      sections: sections.join(','),
      sections_url: window.location.pathname,
    })
      .then(function (data) {
        track('upsell_add', { item_id: item.dataset.variantId, item_name: item.dataset.title, placement: 'cart' });
        var s = data.sections || {};
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && s['cart-icon-bubble']) bubble.innerHTML = inner(s['cart-icon-bubble'], '.shopify-section');
        if (items && s[items.dataset.id]) {
          var html = inner(s[items.dataset.id], '.js-contents');
          if (html !== null) items.querySelector('.js-contents').innerHTML = html;
        }
        if (footer && s[footer.dataset.id]) {
          var fhtml = inner(s[footer.dataset.id], '.js-contents');
          if (fhtml !== null) footer.querySelector('.js-contents').innerHTML = fhtml;
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = T('failed', '追加できませんでした。もう一度お試しください');  // dcw-i18n-ignore JSON が無いときの予備（日本語ページと同じ文言）
      });
  });
})();
